import {memo, type ReactNode} from "react";
import {Box, Flex} from "@chakra-ui/react";

/**
 * Stacks every content state a button can show into a single grid cell — only `active` is
 * visible, the rest render as invisible "ghosts" — so the button reserves room for its widest
 * real content.
 *
 * `gap` mirrors the `size="xs"` button recipe so the ghosted rows lay out identically.
 */
export const ButtonContentSizer = memo(({active, variants}: {active: number; variants: ReactNode[]}) => (
  <Box display="grid" placeItems="center">
    {variants.map((content, i) => (
      <Flex
        key={i}
        gridArea="1 / 1"
        align="center"
        gap="1"
        visibility={i === active ? "visible" : "hidden"}
        aria-hidden={i !== active}
      >
        {content}
      </Flex>
    ))}
  </Box>
));
